import { render, staticRenderFns } from "./Addproduct-EA.vue?vue&type=template&id=cdfe6456"
import script from "./Addproduct-EA.vue?vue&type=script&lang=js"
export * from "./Addproduct-EA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports